import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import get from 'lodash/fp/get';

import { getGuestRequests$ } from 'api/messenger';
import {
	fetchGuestRequestsFulfilled,
	fetchGuestRequestsFailed,
} from 'store/guestRequests/guestRequests.slice';

export default function unauthenticatedBookingItineraryPathActions({
	reservationId,
	state,
}) {
	const bookingId = get([
        'bookings',
        'byReservationId',
        reservationId,
        'bookingId',
    ])(state);

	if (!bookingId) {
		return of({ actions: [] });
	}

	return getGuestRequests$({ bookingId }).pipe(
		map(guestRequests => ({
			actions: [
				fetchGuestRequestsFulfilled({
					reservationId,
					guestRequests,
				}),
			],
		})),

		catchError(error => of(fetchGuestRequestsFailed({ reservationId, error })))
	);
}
